/**
 * FairIconButton — RedisiginProductPage Icon button (1:966)
 */
import type { FairRdIconContainerSize } from '@/ui/tokens/redesign.data'

export const FAIR_ICON_BUTTON_SIZES = ['medium', 'small', 'mobile', 'mobile-compact'] as const
export type FairIconButtonSize = (typeof FAIR_ICON_BUTTON_SIZES)[number]

/**
 * T-120 — Tone (Icon button `155:16923`): Default secondary (hover / pressed primary),
 * Subtle muted, Strong primary always (no hover change).
 */
export const FAIR_ICON_BUTTON_TONES = ['default', 'subtle', 'strong'] as const
export type FairIconButtonTone = (typeof FAIR_ICON_BUTTON_TONES)[number]

export const FAIR_ICON_BUTTON_PREVIEW_STATES = [
  'idle',
  'hovered',
  'pressed',
  'disabled',
] as const
export type FairIconButtonPreviewState =
  (typeof FAIR_ICON_BUTTON_PREVIEW_STATES)[number]

/**
 * Hit + glyph sizes from Figma Medium 44 / Small 32 / Mobile 44 · icon 20 ·
 * Mobile compact 44 · icon 16 (product card on mobile, T-120)
 *
 * `icon` описан размером контейнера иконки, а не просто `number`: значение
 * уходит прямо в проп `size` у `FairIconContainer`, который принимает только
 * размеры из `FAIR_RD_ICON_CONTAINER_SIZES`.
 */
export const FAIR_ICON_BUTTON_METRICS: Record<
  FairIconButtonSize,
  { box: number; icon: FairRdIconContainerSize; pad: number }
> = {
  medium: { box: 44, icon: 20, pad: 12 },
  small: { box: 32, icon: 16, pad: 8 },
  mobile: { box: 44, icon: 20, pad: 12 },
  'mobile-compact': { box: 44, icon: 16, pad: 14 },
}
